<template>
  <b-container fluid v-if="!busy">
    <b-row>
      <b-col cols="12" class="mb-4">
        <!-- #region header -->
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <b-button variant="link" class="border rounded bg-white mr-3" v-on:click="$emit('close')">
              <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
            </b-button>
            <h4 class="m-0"># {{ document._orderID || '0000' }}</h4>
          </div>
          <div>
            <b-button v-on:click="$refs['delete-modal'].toggle()" variant="danger">Delete</b-button>
          </div>
        </div>
        <!-- #endregion -->
      </b-col>
      <b-col cols="12" md="8">
        <!-- #region preview -->
        <b-card style="height: 500px" class="bg-white">
          <div class="position-relative h-100 d-flex align-items-center justify-content-center">
            <template v-if="settings.request?.useProductImage">
              <img class="position-absolute" style="top: 0; height: 100%" :src="document.configuration.product.image" :alt="document.configuration.product.name" onerror="this.style.display='none'" />
            </template>
            <template v-else>
              <template v-for="(option, index) in document.configuration.options">
                <template v-if="option.document && option.document['front']">
                  <img class="position-absolute" style="top: 0; height: 100%" :src="option.document['front']" :alt="option.document.name" :key="index" onerror="this.style.display='none'" />
                </template>
              </template>
            </template>
          </div>
        </b-card>
        <!-- #endregion -->

        <!-- #region note -->
        <!-- <b-card class="mt-4">
          <template #header>
            <div class="d-flex justify-content-between align-items-center py-3 px-2">
              <h5 class="m-0">Notes</h5>
            </div>
          </template>
          <div class="note__item">
            <p class="message">We called him, and he said to call back next week.</p>
            <p class="mb-0 text-muted">Marius Winsjansen</p>
            <p class="text-muted">01/23/2024</p>
          </div>
          <div class="note__item">
            <p class="message">We called him, and he said to call back next week.</p>
            <p class="mb-0 text-muted">Marius Winsjansen</p>
            <p class="text-muted">01/23/2024</p>
          </div>
          <b-form-textarea id="textarea" v-model="text" placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>
        </b-card> -->
        <!-- #endregion -->
        <!-- #region options -->
        <b-card class="mt-4">
          <template #header>
            <div class="d-flex justify-content-between align-items-center py-3 px-2">
              <h5 class="m-0">{{ document.configuration.product.name }}</h5>
              <h5 class="m-0">{{ formatToCurrency(document.configuration.price || '0', Currency.EURO) }}</h5>
            </div>
          </template>
          <div class="d-flex justify-content-between align-items-center px-2" v-for="(option, index) in document.configuration.options" :key="index">
            <template v-if="option">
              <p class="m-0" style="font-size: 14px">
                {{ option.document.name }}
              </p>
              <div class="d-flex" style="gap: 1rem">
                <p v-if="option.price && option.price != option.document.price" class="m-0" style="font-size: 14px; width: 75px">
                  <s>{{ formatToCurrency(option.price || option.document.price || '0', Currency.EURO) }}</s>
                </p>
                <p class="m-0" style="font-size: 14px; width: 75px">{{ formatToCurrency(option.price || option.document.price || '0', Currency.EURO) }}</p>
              </div>
            </template>
          </div>
        </b-card>
        <!-- #endregion -->
      </b-col>
      <b-col cols="12" md="4">
        <!-- #region contact -->
        <b-card>
          <template #header>
            <div class="py-3 px-2">
              <h5 class="m-0">Contact</h5>
            </div>
          </template>
          <div class="px-2">
            <p>{{ document.firstname }} {{ document.lastname }}</p>
            <div class="d-flex align-items-center mb-3">
              <b-icon class="mr-2 text-primary" font-scale="1.25" icon="geo-alt-fill" aria-hidden="true"></b-icon>
              <p class="m-0">{{ document.zipCode }} {{ document.city }}, {{ getCountryByCode(document.country) }}</p>
            </div>
            <div class="mb-3">
              <a :href="`mailto:${document.email}`">{{ document.email }}</a>
            </div>
            <div class="mb-3">
              <a :href="`tel:${document.phone}`">{{ document.phone }}</a>
            </div>
            <!-- <div style="display: flex; gap: 10px">
              <b-button variant="primary">Call number</b-button>
              <b-button variant="primary">Write email</b-button>
              <b-button variant="primary">Share build</b-button>
            </div> -->
          </div>
        </b-card>
        <!-- #endregion -->
        <!-- #region dealer -->
        <b-card class="mt-4">
          <template #header>
            <div class="d-flex justify-content-between align-items-center py-3 px-2">
              <h5 class="m-0">Assigned dealer</h5>
              <p class="m-0 text-primary font-weight-bold" style="cursor: pointer" v-on:click="$refs['dealer-modal'].toggle()">{{ document.dealer ? 'Reassign' : 'Assign' }}</p>
            </div>
          </template>
          <div class="px-2">
            <template v-if="document.dealer">
              <p class="m-0">{{ document.dealer.name }}</p>
              <!-- <div class="d-flex align-items-center mb-3">
                <b-icon class="mr-2 text-primary" font-scale="1.25" icon="geo-alt-fill" aria-hidden="true"></b-icon>
                <p class="m-0">{{ document.dealer.address }}</p>
              </div> -->
            </template>
            <template v-else>
              <p>No dealer asigned yet.</p>
            </template>
          </div>
        </b-card>
        <!-- #endregion -->
        <!-- #region comment -->
        <b-card v-if="document.textarea" class="mt-4">
          <template #header>
            <div class="d-flex justify-content-between align-items-center py-3 px-2">
              <h5 class="m-0">Comment</h5>
            </div>
          </template>
          <div class="px-2">
            <p>{{ document.textarea }}</p>
          </div>
        </b-card>
        <!-- #endregion -->
      </b-col>
    </b-row>
    <!-- #region dealer-modal -->
    <b-modal hide-footer ref="dealer-modal" centered title="Reassign dealer">
      <p>Select dealer</p>
      <b-form-select v-model="dealer" :options="dealers">
        <template #first>
          <b-form-select-option :value="null" disabled>Select dealer</b-form-select-option>
        </template>
      </b-form-select>
      <div class="mt-4">
        <b-button class="mr-3" v-on:click="$refs['dealer-modal'].toggle()">Cancel</b-button>
        <b-button variant="primary" :disabled="!dealer" v-on:click="updateDealer">Save</b-button>
      </div>
    </b-modal>
    <!-- #endregion -->
    <!-- #region delete-modal -->
    <b-modal hide-footer ref="delete-modal" centered title="Delete request">
      <p>Are you sure you want to delete the request?</p>
      <div class="mt-4">
        <b-button class="mr-3" v-on:click="$refs['delete-modal'].toggle()">Cancel</b-button>
        <b-button variant="danger" v-on:click="deleteRequest">Delete</b-button>
      </div>
    </b-modal>
    <!-- #endregion -->
  </b-container>
</template>

<script>
// #region import
import { getCountryByCode, formatToCurrency, Currency } from '@/utils'
import { mapActions, mapState } from 'vuex'
// #endregion

export default {
  name: 'dRequest',
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      busy: true,
      document: {},
      dealers: [],
      dealer: null,
      // #region utils
      Currency,
      // #endregion
    }
  },
  computed: {
    ...mapState({
      settings: (state) => state.firestore.settings,
    }),
  },
  async created() {
    try {
      // prettier-ignore
      (await this['firestore/getDocs']({ path: 'dealers' })).sort((a, b) => a.name.localeCompare(b.name)).forEach((dealer) => {
        this.dealers.push({
          text: dealer.name,
          value: dealer,
        });
      });

      this.document = await this['firestore/getDoc']({ path: this.path })
      this.document.dealer = await this['firestore/getDoc']({ path: this.document.dealer.path })
      this.dealer = this.document.dealer || null
      this.document.configuration = await this['firestore/getDoc']({ path: this.document.configuration.path })
      this.document.configuration.product = await this['firestore/getDoc']({ path: this.document.configuration.product.path })
      console.log('options', this.document.configuration.options)
      // option objectet overskriver, så jeg har ikke lengre discount
      await Promise.all(
        this.document.configuration.options.map(async (option, i) => {
          console.log(option, option._reference, option.path)
          const document = await this['firestore/getDoc']({
            path: option._reference ? 'options/' + option._reference : option.path,
          })
          this.document.configuration.options[i].document = document
        })
      )

      this.busy = false
    } catch (error) {
      console.log('catch', error)
    }
  },
  methods: {
    // #region actions
    ...mapActions(['firestore/getDoc', 'populateDocument', 'firestore/updateDoc', 'firestore/deleteDocs', 'functions/forwardRequest', 'firestore/getDocs']),
    // #endregion
    // #region utils
    formatToCurrency,
    getCountryByCode,
    // #endregion
    async deleteRequest() {
      try {
        await this['firestore/deleteDocs']({
          paths: [this.document._reference.path, this.document.configuration._reference.path],
        })
        this.$emit('close')
      } catch (error) {
        console.log('catch', error)
      }
    },
    async updateDealer() {
      try {
        this.busy = true
        await this['firestore/updateDoc']({ path: this.path, data: { dealer: this.dealer._reference } })
        this.document.dealer = this.dealer
        this.busy = false
      } catch (error) {
        console.log('catch', error)
      } finally {
        this.busy = false
      }
    },
  },
}
</script>

<style lang="scss">
.note {
  &__item {
    background-color: rgb(238, 238, 238);
    padding: 20px;
    padding-bottom: 0px;
    border-bottom: 2px solid rgb(206, 206, 206);
  }
  &__item:not(:last-child) {
    margin-bottom: 20px;
  }
}
</style>
